import request from '@/utils/request';

/**
 *获取文章列表
 * @param params
 * @returns {Promise<*>}
 */
export const sourceList = params => {
  const gql = `query sourceList($query: FormQuery) {
    pub {
      sourceList(query: $query) {
        data {
          viewUnique
          sourceSelf {
            acc
            valVisit
            valUnique
            viewVisit
            viewUnique
          }
          firstHitTime
          lastHitTime
          description
          parent
          acc
          uid
          hash
          createTime
          status
          statusCtrl
          key
          title
          image
          comment
          commentTxt
          source
          valVisit
          viewVisit
          valUnique
          viewUnique
          diffUnique
          numForward
          isMeForward
          isSample
          numChild
        }
        meta {
          page
          count
        }
      }
    }
  }`;
  return request(gql, params, 'surl', '获取文章');
};
/**
 *获取明细列表
 * @param params
 * @returns {Promise<*>}
 */
export const sourceDetailList = params => {
  const gql = `query sourceDetailList($acc: String!, $query: FormQuery) {
  pub {
    source(acc: $acc) {
      historyList(query: $query) {
        data {
          userInfo {
            userInfo {
              profile {
                realName
              }
            }
          }
          who
          acc
          parent
          areaKey
          isp
          cate
          createTime
          updateTime
          areaName
          numVisit
          numVisitMonth
          isIgnore
        }
        meta {
          count
          page
          limit
        }
      }
    }
  }
}`;
  return request(gql, params, 'surl', '获取明细列表');
};

export const divisionInfo = params => {
  const gql = `query divisionInfo($form: FormAreaQuery!) {
  pub {
    divisionInfo(form: $form) {
      cate
      key
      parent
      index
      name
    }
  }
}`;
  return request(gql, params, 'user', '城市');
};
/**
 *获取文章详情
 * @param params
 * @returns {Promise<*>}
 */
export const source = params => {
  const gql = `query source($acc: String!) {
  pub {
    source(acc: $acc) {
      awardRules {
        numLevel
        numMatch
        valAward
      }
      viewUnique
      sourceSelf {
        acc
        valVisit
        viewVisit
        valUnique
        viewUnique
      }
      parentInfo {
        statusCtrl
      }
      firstHitTime
      lastHitTime
      description
      acc
      uid
      hash
      parent
      createTime
      status
      statusCtrl
      key
      title
      image
      comment
      commentTxt
      source
      valVisit
      viewVisit
      valUnique
      viewUnique
      diffUnique
      numForward
      isMeForward
      isSample
      numChild
    }
  }
}`;
  return request(gql, params, 'surl', '获取文章详情');
};
/**
 *转载文章
 * @param params
 * @returns {Promise<*>}
 */
export const forwardSource = params => {
  const gql = `mutation forwardSource($form: ForwardSource!) {
    meExec {
      forwardSource(form: $form) {
        acc
      }
    }
  }`;
  return request(gql, params, 'surl', '转载文章');
};

/**
 * 增加浏览次数
 * @param params
 * @returns {Promise<*>}
 */
export const hitSourceAsync = params => {
  const gql = `query hitSourceAsync($form: HitSource!) {
    pub {
      hitSourceAsync(form: $form)
    }
  }`;
  return request(gql, params, 'surl', '增加浏览次数');
};
